(function (global, factory) {
  typeof exports === 'object' && typeof module !== 'undefined' ? factory(exports) :
  typeof define === 'function' && define.amd ? define(['exports'], factory) :
  (global = typeof globalThis !== 'undefined' ? globalThis : global || self, factory(global.d3 = {}));
}(this, (function (exports) { 'use strict';

  function _defineProperty(obj, key, value) {
    if (key in obj) {
      Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
      });
    } else {
      obj[key] = value;
    }

    return obj;
  }

  function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);

    if (Object.getOwnPropertySymbols) {
      var symbols = Object.getOwnPropertySymbols(object);
      if (enumerableOnly) symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
      keys.push.apply(keys, symbols);
    }

    return keys;
  }

  function _objectSpread2(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i] != null ? arguments[i] : {};

      if (i % 2) {
        ownKeys(Object(source), true).forEach(function (key) {
          _defineProperty(target, key, source[key]);
        });
      } else if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
      } else {
        ownKeys(Object(source)).forEach(function (key) {
          Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
      }
    }

    return target;
  }

  function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;

    for (i = 0; i < sourceKeys.length; i++) {
      key = sourceKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      target[key] = source[key];
    }

    return target;
  }

  function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};

    var target = _objectWithoutPropertiesLoose(source, excluded);

    var key, i;

    if (Object.getOwnPropertySymbols) {
      var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

      for (i = 0; i < sourceSymbolKeys.length; i++) {
        key = sourceSymbolKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
        target[key] = source[key];
      }
    }

    return target;
  }

  function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
  }

  function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
  }

  function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter);
  }

  function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
  }

  function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;

    for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];

    return arr2;
  }

  function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }

  /**
   * Generate the points and angle for a single section of the parliament
   *
   * @param seats - number of seats in this section
   * @param startRad - start radians of this section
   * @param endRad - end radians of this section
   * @param seatRadius - radius of the seats
   * @param rowHeight - height of the row
   * @param graphicHeight - height of the graphic
   * @param sectionGap - The gap between sections
   * @returns {[]}
   */
  var generatePartial = function generatePartial(_ref) {
    var seats = _ref.seats,
        startRad = _ref.startRad,
        endRad = _ref.endRad,
        seatRadius = _ref.seatRadius,
        rowHeight = _ref.rowHeight,
        graphicHeight = _ref.graphicHeight,
        sectionGap = _ref.sectionGap;
    // Calculate the radius of the graph, because we don't want the poitns to extend
    // beyond the width of the graphic
    var graphRadius = graphicHeight - seatRadius; // Final Array

    var points = []; // Which row we are currently drawing

    var currentRow = 0; // Create all the points

    while (points.length < seats) {
      // The radius of the row we are currently drawing
      var currentRowRadius = graphRadius - rowHeight * currentRow; // We need to also justify for the gap of the section, which radians value varies per row

      var currentRowGapRad = Math.atan((seatRadius + sectionGap / 2) / currentRowRadius);
      var currentRowStartRad = startRad + currentRowGapRad;
      var currentRowEndRad = endRad - currentRowGapRad; // If our data doesn't fit inside the row or the graph, we just stop

      if (currentRowEndRad <= currentRowStartRad || currentRowRadius <= 0) break; // Find the minimum size step given the radius

      var currRadStep = Math.atan(2.5 * seatRadius / currentRowRadius); // Find how many seats are in this row

      var rowSeats = Math.min(Math.floor((currentRowEndRad - currentRowStartRad) / currRadStep), seats - points.length - 1); // Get adjusted step size so that things are justified evenly
      // edge case if there is only one seat in this row

      var roundedRadStep = rowSeats ? (currentRowEndRad - currentRowStartRad) / rowSeats : 0; // Add all the seats in this row

      for (var currSeat = 0; currSeat <= rowSeats; currSeat += 1) {
        // Get the current angle of the seat we are drawing
        var currentAngle = rowSeats ? currSeat * roundedRadStep + currentRowStartRad : // edge case if there is only one seat in this row, we put it in the middle
        (currentRowStartRad + currentRowEndRad) / 2; // convert the angle to x y coordinates

        points = points.concat([{
          x: Math.cos(currentAngle) * (graphRadius - rowHeight * currentRow) + graphicHeight,
          // flip the y coordinates
          y: graphicHeight - (Math.sin(currentAngle) * (graphRadius - rowHeight * currentRow) + seatRadius) // Add seatRadius and any sectionGap / 4 so that we vertically center
          + seatRadius + sectionGap / 4,
          angle: currentAngle
        }]);
      }

      currentRow += 1;
    }

    return points;
  };
  /**
   * Generates the list of all points and their x and y positions
   *
   * @param totalPoints - total number of points we want to draw
   * @param sections - total number of sections we want to draw
   * @param sectionGap - gap between sections
   * @param seatRadius - radius of each seat
   * @param rowHeight - height of each row
   * @param graphicWidth - width of the entire graphic
   * @returns {this}
   */


  var getParliamentPoints = (function (totalPoints, _ref2, graphicWidth) {
    var sections = _ref2.sections,
        sectionGap = _ref2.sectionGap,
        seatRadius = _ref2.seatRadius,
        rowHeight = _ref2.rowHeight;
    // Calculate the graphic height
    var graphicHeight = graphicWidth / 2; // Get the number of final sections

    var finalSections = Math.min(totalPoints, sections); // Angle step per section in radians

    var radStep = Math.PI / finalSections; // Divide the seats evenly among the sections, while also calculating
    // the start radians and end radians.

    var sectionObjs = Array(finalSections) // First evenly divide the seats into each section
    .fill({
      seats: Math.floor(totalPoints / finalSections)
    }) // add the start and end radians
    .map(function (a, i) {
      return _objectSpread2(_objectSpread2({}, a), {}, {
        startRad: i * radStep,
        endRad: (i + 1) * radStep
      });
    }); // There are leftover seats that we need to fit into sections
    // Calculate how many there are

    var leftoverSeats = totalPoints % finalSections; // If leftover seats is 0, we can skip this entire section

    if (leftoverSeats !== 0) {
      // We want to add the leftover seats to the center section first, then move outward
      // We do this by separating the sections into two arrays, left and right
      var right = Array(finalSections).fill(null).map(function (c, i) {
        return i;
      });
      var left = right.splice(0, Math.floor(finalSections / 2)).reverse(); // Add the seats

      while (leftoverSeats > 0) {
        // Whichever array is longer, we pop from that array and add to that section first
        if (left.length >= right.length) sectionObjs[left.shift()].seats += 1;else sectionObjs[right.shift()].seats += 1; // decrement leftoverSeats by one

        leftoverSeats -= 1;
      }
    } // Call the section partial generation tool for each section


    return sectionObjs.map(function (s) {
      return generatePartial(_objectSpread2(_objectSpread2({}, s), {}, {
        seatRadius: seatRadius,
        rowHeight: rowHeight,
        graphicHeight: graphicHeight,
        sectionGap: sectionGap
      }));
    }) // flatten the array
    .reduce(function (acc, val) {
      return [].concat(_toConsumableArray(acc), _toConsumableArray(val));
    }, []) // sort by angle
    .sort(function (a, b) {
      return b.angle - a.angle;
    }) // remove angle from returned dataset
    .map(function (r) {
      var angle = r.angle,
          rest = _objectWithoutProperties(r, ["angle"]);

      return rest;
    });
  });

  var debugColor = '#1abc9c';
  /**
   * Draw Debugging circle and section guides.
   */

  var debugGuides = (function (selection, graphicWidth, options, totalSeats) {
    var sections = Math.min(totalSeats, options.sections); // Create a container for our debug lines

    var g = selection.append('g').attr('class', 'debug').attr('transform', "translate(0, ".concat(options.sectionGap / 4, ")")); // The radius of the semicircle

    var radius = graphicWidth / 2; // Semicircle frame

    g.append('path').attr('d', "M".concat(graphicWidth, ",").concat(radius, " a1,1 0 0,0 -").concat(graphicWidth, ",0 m 0 -").concat(options.sectionGap / 2, " l ").concat(graphicWidth, " 0")).attr('stroke', debugColor).attr('stroke-width', 2).attr('stroke-dasharray', '5 5').attr('fill', 'none'); // Section borders

    var radStep = Math.PI / sections;

    for (var i = 1; i < sections; i += 1) {
      var radAngle = radStep * i; // If the section gap is 0 we only need to draw one line

      if (options.sectionGap <= 0) {
        g.append('line').attr('x1', radius).attr('y1', radius).attr('x2', Math.cos(radAngle) * radius + radius).attr('y2', radius - Math.sin(radAngle) * radius).attr('stroke', debugColor).attr('stroke-width', 2).attr('stroke-dasharray', '5 5');
      } else {
        // Calculate the offset and draw two lines.
        var offsetX = Math.sin(radAngle) * (options.sectionGap / 2);
        var offsetY = Math.cos(radAngle) * (options.sectionGap / 2);
        g.append('line').attr('x1', radius - offsetX).attr('y1', radius - offsetY).attr('x2', Math.cos(radAngle) * radius + radius - offsetX).attr('y2', radius - Math.sin(radAngle) * radius - offsetY).attr('stroke', debugColor).attr('stroke-width', 2).attr('stroke-dasharray', '5 5');
        g.append('line').attr('x1', radius + offsetX).attr('y1', radius + offsetY).attr('x2', Math.cos(radAngle) * radius + radius + offsetX).attr('y2', radius - Math.sin(radAngle) * radius + offsetY).attr('stroke', debugColor).attr('stroke-width', 2).attr('stroke-dasharray', '5 5');
      }
    }
  });

  /**
   *  ___ ____    ___          _ _                    _       ___ _             _
   * |   \__ /   | _ \__ _ _ _| (_)__ _ _ __  ___ _ _| |_    / __| |_  __ _ _ _| |_
   * | |) |_ \   |  _/ _` | '_| | / _` | '  \/ -_) ' \  _|  | (__| ' \/ _` | '_|  _|
   * |___/___/   |_| \__,_|_| |_|_\__,_|_|_|_\___|_||_\__|   \___|_||_\__,_|_|  \__|
   *
   * A d3 plugin for making semi-circle parliament charts.
   */

  var parliamentChart = (function () {
    var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    var width = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
    // Dimensions of the graphic
    var graphicWidth = parseFloat(width); // clean out any x and y values provided in data objects.

    var rawData = data.map(function (_ref) {
      var x = _ref.x,
          y = _ref.y,
          restProps = _objectWithoutProperties(_ref, ["x", "y"]);

      return restProps;
    }); // visual options

    var options = {
      sections: 4,
      // Number of sections to divide the half circle into
      sectionGap: 60,
      // The gap of the aisle between sections
      seatRadius: 12,
      // The radius of each seat
      rowHeight: 42 // The height of each row

    }; // Whether we should draw the debug lines or not

    var debug = false; // //////////////////////////////////////////////////////////////////////////
    // Selection call
    //
    // This function gets called on instances such as:
    //    d3.select('g').call(parliamentChart())

    var parliamentChart = function parliamentChart(selection) {
      if (graphicWidth === 0) {
        // Sets the graphicWidth based on our selected container
        graphicWidth = selection.node().getBoundingClientRect().width;
      } // Get the processed data (filter for entries that have x and y locations)


      var processedData = parliamentChart.data().filter(function (r) {
        return r.x && r.y;
      }); // Remove existing chart

      selection.select('g.parliament-chart').remove(); // Add new chart

      var innerSelection = selection.append('g').attr('class', 'parliament-chart'); // First remove any existing debug lines

      innerSelection.select('g.debug').remove(); // Append debug lines

      if (debug) debugGuides(innerSelection, graphicWidth, options, processedData.length);
      return innerSelection.selectAll('circle').data(processedData).enter().insert('circle').attr('cx', function (d) {
        return d.x;
      }).attr('cy', function (d) {
        return d.y;
      }).attr('r', options.seatRadius).attr('fill', function (d) {
        return d.color || '#AAA';
      });
    }; // //////////////////////////////////////////////////////////////////////////
    // Getters and Setters
    // Sets the width and the height of the graphic


    parliamentChart.width = function (w) {
      // eslint-disable-next-line no-restricted-globals
      if (!isNaN(w)) {
        // parse the width
        graphicWidth = parseFloat(w);
      }

      return parliamentChart;
    }; // Create getters and setters for sections, sectionGap, seatRadius, and rowHeight


    Object.keys(options).forEach(function (attr) {
      parliamentChart[attr] = function (s) {
        // eslint-disable-next-line no-restricted-globals
        if (!isNaN(s)) {
          options[attr] = parseInt(s, 10);
          return parliamentChart;
        }

        return options[attr];
      };
    }); // enable / disable debug mode

    parliamentChart.debug = function (b) {
      debug = !!b;
      return parliamentChart;
    }; // //////////////////////////////////////////////////////////////////////////
    // Data Processing
    //
    // Gets the data processed data with x and y coordinates or sets
    // the raw data.


    parliamentChart.data = function (d) {
      // If an argument with new data is provided
      if (d) {
        // clean out any x and y values provided in data objects.
        rawData = d.map(function (_ref2) {
          var x = _ref2.x,
              y = _ref2.y,
              restProps = _objectWithoutProperties(_ref2, ["x", "y"]);

          return restProps;
        });
        return parliamentChart;
      } // If width is not set, don't calculate this instance


      if (graphicWidth <= 0 || rawData.length <= 0) return rawData; // Check if we have already run this instance

      if (rawData.every(function (r) {
        return r.x && r.y;
      })) return rawData; // The number of points we need to fit

      var totalPoints = rawData.length; // The locations of all the points

      var locations = getParliamentPoints(totalPoints, options, graphicWidth); // Add locations to the rawData object

      locations.forEach(function (coords, i) {
        return rawData[i] = _objectSpread2(_objectSpread2({}, rawData[i]), coords);
      }); // return the data

      return rawData;
    }; // Instead of passing in an array of every single point, we pass in an array of objects
    // that each have a key `seats` that specifies the number of seats. This function can only
    // set, not get.


    parliamentChart.aggregatedData = function (d) {
      rawData = d.reduce(function (acc, val) {
        var _val$seats = val.seats,
            seats = _val$seats === void 0 ? 0 : _val$seats,
            x = val.x,
            y = val.y,
            restProps = _objectWithoutProperties(val, ["seats", "x", "y"]);

        return [].concat(_toConsumableArray(acc), _toConsumableArray(Array(seats).fill(restProps)));
      }, []);
      return parliamentChart;
    };

    return parliamentChart;
  });

  exports.parliamentChart = parliamentChart;

  Object.defineProperty(exports, '__esModule', { value: true });

})));
